<div class="ctr">
  <p [innerHTML]="getHtml()"></p>
</div>
